import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import SeniorCitizenContainer from './senior-citizen/container/SeniorCitizenContainer';
import TransactionsContainer from './dashboard/TransactionsContainer';
import PWDContainer from './pwd/container/PWDContainer';
import StudentContainer from './student/container/StudentContainer';
import SingleParentContainer from './single-parent/container/SingleParentContainer';
import SocialAmeliorationSettings from './settings/SocialAmeliorationSettings';

const SocialAmeliorationContainer = ({ match }) => {
  const permissions = getJson('permissions');
  return (
    <div className="module-inner">
      <div className="module-inner-title">Social Amelioration</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION DASHBOARD']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/social-ameliorations"
          >
            Dashboard
          </NavLink>
        )}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION SENIOR']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/social-ameliorations/seniors"
          >
            Senior Citizen
          </NavLink>
        )}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION PWD']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/social-ameliorations/pwd"
          >
            PWD
          </NavLink>
        )}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION STUDENT']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/social-ameliorations/students"
          >
            Students
          </NavLink>
        )}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION SINGLE PARENT']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/social-ameliorations/single-parent"
          >
            Solo Parents
          </NavLink>
        )}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION SETTINGS']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/social-ameliorations/settings"
          >
            Settings
          </NavLink>
        )}
      </div>
      <Switch>
        {/* TransactionContainer === Dashboard */}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION DASHBOARD']) && (
          <Route exact path={`${match.path}`} component={TransactionsContainer} />
        )}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION SENIOR']) && (
          <Route
            path={`${match.path}/seniors`}
            component={SeniorCitizenContainer}
          />
        )}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION PWD']) && (
          <Route
            path={`${match.path}/pwd`}
            component={PWDContainer}
          />
        )}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION STUDENT']) && (
          <Route
            path={`${match.path}/students`}
            component={StudentContainer}
          />
        )}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION SINGLE PARENT']) && (
          <Route
            path={`${match.path}/single-parent`}
            component={SingleParentContainer}
          />
        )}
        {Acl(permissions, ['VIEW SOCIAL AMELIORATION SETTINGS']) && (
          <Route
            path={`${match.path}/settings`}
            component={SocialAmeliorationSettings}
          />
        )}
      </Switch>
    </div>
  );
};

SocialAmeliorationContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(SocialAmeliorationContainer);
